module.exports = __webpack_public_path__ + "media/shi.cd1286d9.wav";